import ApiBase from 'Services/Api/ApiBase';

class NotificationLogs extends ApiBase {
    route = '/admin/comms/notification-logs';
}

export default new NotificationLogs();
